/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createContext, type Context } from 'react';
import type { AdditionalEventAttributes } from '@jira/platform__experience-tracking-analytics/src/index.tsx';

// Each `ExperienceTracker` will call these functions to signal to the provider
// the status of a key part of the experience. The provider will aggregate that information
// and determine whether the experience as a whole succeeded or failed.
export type ConsumerCallbacks = {
	onPending: (experienceTrackerId: string) => void;
	onClearPending: (experienceTrackerId: string) => void;
	// TODO: Make this required on cleanup of: jfp-magma-fix-experience-tracker-concurrency
	// Currently needs to be optional for the legacy path in jira/src/packages/issue/status/src/StatusView.tsx
	onSuccess: (experienceTrackerId?: string) => void;
	onFailure: (location: string, additionalAttributes?: AdditionalEventAttributes) => void;
	onAbort: (location: string, additionalAttributes?: AdditionalEventAttributes) => void;
};

export type ExperienceContext = {
	consumerCallbacks: ConsumerCallbacks;
	experience: string;
	experienceId: string | null | undefined;
};

const ExperienceContext: Context<ExperienceContext | null> =
	createContext<ExperienceContext | null>(null);
export default ExperienceContext;
